/** Product listing — the price-comparison entry point. */

import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Products reuse the search page entirely.
 *
 * A separate implementation would drift: two filter bars, two pagination
 * behaviours, two definitions of "sort by price". This redirects instead, so
 * there is one search surface with one set of semantics.
 */
export function ProductsPage() {
  const [params] = useSearchParams()
  const next = new URLSearchParams(params)
  next.set('type_of', 'product')
  return <Navigate to={`/search?${next.toString()}`} replace />
}
